import styled, { css } from "styled-components";

/** Dimensions scaled ×1.2 vs original for login preview hero cards */
export const Stack = styled.div`
  position: relative;
  width: 339.6px;
  height: 189.6px;
  flex-shrink: 0;
  margin: 0 auto;
`;

const stackedImageBase = css`
  position: absolute;
  border-radius: 9.6px;
  object-fit: cover;
  pointer-events: none;
`;

export const BackLeftImg = styled.img`
  ${stackedImageBase}
  top: 0;
  left: 0;
  width: 278.4px;
  height: 163.2px;
  transform: rotate(-4deg);
  filter: blur(0.85px);
`;

export const BackRightImg = styled.img`
  ${stackedImageBase}
  top: 3.6px;
  left: 68.4px;
  width: 271.2px;
  height: 159.6px;
  transform: rotate(5deg);
  filter: blur(0.5px);
`;

export const FrontImg = styled.img`
  ${stackedImageBase}
  top: 18px;
  left: 31.2px;
  width: 296.4px;
  height: 171.6px;
  border: 1px solid #1656cf;
`;

export const IconButton = styled.div`
  position: absolute;
  top: 63.6px;
  left: 145.2px;
  width: 62.4px;
  height: 62.4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 100px;
  color: #1656cf;
`;
